import {isEmpty} from "lodash"

export const normalizeString = (value, maxLength) => {
    if (!value) return value

    return value.slice(0, maxLength)
}

/**
 * Normalize a string to only numbers
 * The string can still be > to the max integer value
 */
export const normalizeStringOnlyNumbers = (value, maxLength) => {
    // undefined value return undefined
    if (!value) return value

    // Replace any non digit character by nothing
    value = value.replace(/\D/g, "")

    // Block the string to a maxLength
    if (maxLength) return value.slice(0, maxLength)
    else return value
}

/**
 * Guarantee that the string will contains only letters and spaces
 * @param value the value to normalize
 * @param maxLength optionnal parameter, which slice the value
 * @returns {*}
 */
export const normalizeAlphabetString = (value, maxLength) => {
    if (!value) return value

    const onlyLettersAndSpaces = value.replace(/[^a-zA-Z ]/g, "")

    if (maxLength) return onlyLettersAndSpaces.slice(0, maxLength)
    else return onlyLettersAndSpaces
}

/**
 * Guarantee that the string will contains only upper letters, dash, simple quotes and spaces
 * @param value the value to normalize
 * @param maxLength optionnal parameter, which slice the value
 * @returns {*}
 */
export const normalizeAlphabetNumberStringUrssaf = (value, maxLength) => {
    if (!value) return value

    value = value.toUpperCase()
    const onlyLettersAndSpaces = value.replace(/[^A-Z'\- ]/g, "")

    if (maxLength) return onlyLettersAndSpaces.slice(0, maxLength)
    else return onlyLettersAndSpaces
}

/**
 * Guarantee that the string will contains only numbers, letters and spaces
 * @param value the value to normalize
 * @param maxLength optionnal parameter, which slice the value
 * @returns {*}
 */
export const normalizeAlphabetNumberString = (value, maxLength) => {
    if (!value) return value

    const onlyNumbersLettersAndSpaces = value.replace(/[^0-9a-zA-Z ]/g, "")

    if (maxLength) return onlyNumbersLettersAndSpaces.slice(0, maxLength)
    else return onlyNumbersLettersAndSpaces
}

export const normalizeDuration = value => {
    if (!value) return value

    const onlyNumbersAndSplitter = value.replace(/[^0-9:]/g, "")
    const splitted = onlyNumbersAndSplitter.split(":")

    if (splitted.length > 2 || (splitted.length === 2 && splitted[1].length > 2)) {
        return value.slice(0, -1)
    }

    if (splitted.length === 2 && Number(splitted[1]) > 59) {
        return splitted[0] + ":" + 59
    }

    return onlyNumbersAndSplitter
}

export const normalizeUpperCase = value => (!isEmpty(value) ? value.toUpperCase() : undefined)

export const normalizeLowerCase = value => (!isEmpty(value) ? value.toLowerCase() : undefined)

export const normalizeHexColorString = value => {
    if (!value) return value

    const onlyNumbersLetters = value.replace(/[^#A-Fa-f0-9]$/g, "")

    if (value.slice(0, 1) !== "#") {
        return "#" + onlyNumbersLetters
    }

    return onlyNumbersLetters.slice(0, 7)
}

export const normalizeNoSpace = value => {
    if (!value) {
        return value
    }

    return value.replace(/\s/g, "")
}

export const normalizeSpecialChars = input => {
    if (!input) {
        return ""
    }

    return (
        input
            // Normalisation Unicode pour homogénéiser les accents, etc
            .normalize("NFKC")

            // On remplace les apostrophes et guillemets typographiques
            .replace(/[\u2018\u2019\u02BC\uFF07]/g, "'") // ‘ ’ ʹ ＇→ '
            .replace(/[\u201C\u201D\u02DD\uFF02]/g, '"') // “ ” ˝ ＂→ "

            // On remplace les tirets typographiques
            .replace(/[\u2013\u2014\u2212]/g, "-") // – — − → -

            // On remplace les points de suspension typographiques
            .replace(/\u2026/g, "...") // … → ...

            // On remplace les espaces insécables et variantes
            .replace(/[\u00A0\u2007\u202F]/g, " ") // NBSP, Figure space, Narrow NBSP

            // On supprime les caractères invisibles inutiles
            .replace(/[\u200B-\u200D\uFEFF]/g, "") // Zero-width space, joiner, etc

            // On supprime le caractère de remplacement �
            .replace(/\uFFFD/g, "")

            // Trim
            .trim()
    )
}
